(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[141],{

/***/ 99830:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[country]/[language]/help/glossary",
      function () {
        return __webpack_require__(95055);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 96653:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "p": function() { return /* binding */ LocaleTag; }
/* harmony export */ });
/* harmony import */ var _LocaleString__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1809);

// Schema: https://github.com/Global-eCom/sanity-studio-cms/blob/main/studio/schemas/documents/Tag.ts
var LocaleTag = function(field) {
    return "\n  ".concat(field, ' {\n    "value": value.current,\n    ').concat((0,_LocaleString__WEBPACK_IMPORTED_MODULE_0__/* .LocaleString */ .E)("label"), ",\n  }\n");
};


/***/ }),

/***/ 95055:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Glossary; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(5341);
// EXTERNAL MODULE: ../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(24246);
// EXTERNAL MODULE: ./groq/shared/LocaleSeo.ts + 1 modules
var LocaleSeo = __webpack_require__(16138);
// EXTERNAL MODULE: ./groq/shared/LocaleString.ts
var LocaleString = __webpack_require__(1809);
// EXTERNAL MODULE: ./groq/shared/LocaleTag.ts
var LocaleTag = __webpack_require__(96653);
// EXTERNAL MODULE: ./groq/objects/SanityVideoObject.ts
var SanityVideoObject = __webpack_require__(65102);
// EXTERNAL MODULE: ./groq/shared/LocalePortableText.ts
var LocalePortableText = __webpack_require__(57831);
// EXTERNAL MODULE: ./groq/objects/SanityImageObject.ts + 1 modules
var SanityImageObject = __webpack_require__(14075);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ./ui/components/PageHead.tsx
var PageHead = __webpack_require__(9294);
// EXTERNAL MODULE: ../node_modules/twind/css/css.js
var css = __webpack_require__(49224);
// EXTERNAL MODULE: ./ui/components/SanityImage.tsx
var SanityImage = __webpack_require__(86468);
// EXTERNAL MODULE: ./ui/elements/LayoutContainer.tsx
var LayoutContainer = __webpack_require__(2254);
// EXTERNAL MODULE: ./utils/serializeBlockContent.tsx
var serializeBlockContent = __webpack_require__(88313);
// EXTERNAL MODULE: ./utils/isNotNullish.ts
var isNotNullish = __webpack_require__(50597);
// EXTERNAL MODULE: ./ui/components/SanityVideo.tsx + 1 modules
var SanityVideo = __webpack_require__(68020);
;// CONCATENATED MODULE: ./ui/pages/GlossaryPage/GlossaryItem.tsx








/** Render the term, definition, and media for a given glossary item. */ function GlossaryItem(props) {
    var ref, ref1;
    var glossaryItemRef = (0,react.useRef)(null);
    var flexDirection = props.alignment === "right" ? "row" : "row-reverse";
    var isImage = (0,isNotNullish/* isNotNullish */.l)(props.image);
    var isVideo = !isImage && (0,isNotNullish/* isNotNullish */.l)((ref = props.video) === null || ref === void 0 ? void 0 : ref.source);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(LayoutContainer/* Container */.W, {
        bleed: true,
        "data-test-id": "glossary-item",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "absolute invisible -top-24 relative inline-block",
                id: (ref1 = props.term) === null || ref1 === void 0 ? void 0 : ref1.slice(0, 1).toLowerCase()
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                className: "absolute invisible -top-24 relative inline-block",
                id: props.puid
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                className: (0,css.tw)("bg-white flex flex-col relative", "sm:flex-".concat(flexDirection)),
                ref: glossaryItemRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "relative flex-none w-full sm:w-1/2 aspect-3-2",
                        children: [
                            isImage && /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                                source: props.image
                            }),
                            isVideo && /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityVideo/* SanityVideo */.m, {
                                className: "absolute inset-0 h-full object-center object-cover w-full",
                                video: props.video,
                                playsInline: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full flex flex-col justify-center gap-4 mobile:p-6 tablet:p-8 desktop:p-10 xl:p-16",
                        children: [
                            props.term && /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                "data-test-id": "glossary-item-term",
                                className: "max-w-[30ch] font-bold text-3xl sm:text-4xl lg:text-5xl xl:text-6xl",
                                children: props.term
                            }),
                            props.definition && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "max-w-[70ch]",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(serializeBlockContent/* Prose */.Mr, {
                                    content: props.definition
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/@global-ecom/nitro-uds/dist/elements/esm/index.js + 103 modules
var esm = __webpack_require__(12601);
// EXTERNAL MODULE: ../node_modules/next/router.js
var next_router = __webpack_require__(86677);
// EXTERNAL MODULE: ./hooks/useTranslations.tsx
var useTranslations = __webpack_require__(77480);
;// CONCATENATED MODULE: ./ui/pages/GlossaryPage/GlossaryFilters.tsx









function GlossaryFilters(props) {
    var t = (0,useTranslations/* useTranslate */.qM)();
    var router = (0,next_router.useRouter)();
    var ref = (0,react.useState)(""), selectedCategory = ref[0], setSelectedCategory = ref[1];
    var _tags;
    var allTags = props.terms.reduce(function(acc, item) {
        return (0,_to_consumable_array/* default */.Z)(acc).concat((0,_to_consumable_array/* default */.Z)((_tags = item.tags) !== null && _tags !== void 0 ? _tags : []));
    }, []);
    var allFirstLetters = props.filteredTerms.reduce(function(acc, item) {
        return (0,_to_consumable_array/* default */.Z)(acc).concat([
            item.term.slice(0, 1)
        ]);
    }, []).filter(isNotNullish/* isNotNullish */.l).sort();
    var allFirstLettersUnique = (0,_to_consumable_array/* default */.Z)(new Set(allFirstLetters));
    var allTagsUnique = new Map(allTags.map(function(tag) {
        return [
            tag.value,
            tag.label
        ];
    }));
    var glossaryCategoryOptions = Array.from(allTagsUnique).sort().map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], value = _param[1];
        return {
            value: key,
            label: value
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutContainer/* Container */.W, {
        bleed: true,
        id: "glossary-filters",
        className: "border-t border-b",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
            className: "flex justify-between mx-auto w-full max-w-screen-3xl mobile:p-4 tablet:p-6 desktop:p-6",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "flex items-center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                            className: "mr-3",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "sr-only",
                                    children: t("filters")
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Icon */.JO$, {
                                    name: "filter",
                                    size: "xl"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* FilterSelect */.zEy, {
                                value: selectedCategory,
                                dataTestId: "glossary-category-select",
                                id: "glossary-category-select",
                                options: (0,_to_consumable_array/* default */.Z)(glossaryCategoryOptions).concat([
                                    {
                                        value: "all",
                                        label: t("viewAll")
                                    }, 
                                ]),
                                label: t("category"),
                                name: "glossaryCategorySelect",
                                onChange: function(value) {
                                    setSelectedCategory(value.toString());
                                    props.setFilteredTerms(value === "all" ? props.terms : props.terms.filter(function(term) {
                                        var ref;
                                        return (ref = term.tags) === null || ref === void 0 ? void 0 : ref.find(function(tag) {
                                            return tag.value === value;
                                        });
                                    }));
                                },
                                placeholder: t("category")
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* FilterSelect */.zEy, {
                        dataTestId: "glossary-letter-select",
                        id: "glossary-letter-select",
                        options: allFirstLettersUnique === null || allFirstLettersUnique === void 0 ? void 0 : allFirstLettersUnique.map(function(item) {
                            return {
                                value: item,
                                label: item.toUpperCase()
                            };
                        }),
                        label: t("aToZ"),
                        name: "glossaryJumpToLetterSelect",
                        onChange: function(value) {
                            return router.push("#" + value.toString().toLowerCase());
                        },
                        placeholder: t("aToZ")
                    })
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./ui/pages/GlossaryPage/GlossaryPageHeader.tsx



function GlossaryPageHeader(props) {
    if (!(props.headerTitle && props.headerIntroduction && props.headerBackgroundImage)) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LayoutContainer/* Container */.W, {
        bleed: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
            className: "bg-white flex flex-col justify-center items-center text-center relative p-8 w-full h-[60vh]",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SanityImage/* SanityImage */.d, {
                    source: props.headerBackgroundImage
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "relative max-w-screen-md grid gap-[1em]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                            "data-test-id": "glossary-title",
                            className: "font-bold leading-tight uppercase text-5xl md:text-6xl lg:text-7xl xl:text-8xl",
                            children: props.headerTitle
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            "data-test-id": "glossary-intro",
                            className: "text-sm md:text-base max-w-[80ch]",
                            children: props.headerIntroduction
                        })
                    ]
                })
            ]
        })
    });
}

;// CONCATENATED MODULE: ./ui/pages/GlossaryPage/GlossaryPage.tsx







var GlossaryPageHead = function(param) {
    var page = param.page;
    var ref, ref1;
    if (!page) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHead/* PageHead */.y, {
                title: page === null || page === void 0 ? void 0 : (ref = page.seo) === null || ref === void 0 ? void 0 : ref.pageTitle,
                description: "".concat(page === null || page === void 0 ? void 0 : (ref1 = page.seo) === null || ref1 === void 0 ? void 0 : ref1.pageDescription)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlossaryPageHeader, (0,_object_spread/* default */.Z)({}, page.header))
        ]
    });
};
var GlossaryPage = function(param) {
    var page = param.page, terms = param.terms;
    var ref = (0,react.useState)(terms), filteredTerms = ref[0], setFilteredTerms = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlossaryPageHead, {
                page: page
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlossaryFilters, {
                terms: terms,
                filteredTerms: filteredTerms,
                setFilteredTerms: setFilteredTerms
            }),
            filteredTerms.slice().sort(function(a, b) {
                return a.puid.localeCompare(b.puid);
            }).map(function(term, index) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(GlossaryItem, (0,_object_spread/* default */.Z)({
                    alignment: index % 2 === 0 ? "left" : "right"
                }, term), term.puid);
            })
        ]
    });
};

// EXTERNAL MODULE: ./hooks/useGroqQuery.ts
var useGroqQuery = __webpack_require__(95967);
;// CONCATENATED MODULE: ./pages/[country]/[language]/help/glossary/index.tsx










function useGlossaryPageQuery() {
    return (0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "GlossaryPage",
        query: '\n      *[_type == "GlossaryPage" && country == upper($country)][0] {\n        "header": {\n          '.concat((0,SanityImageObject/* SanityImageObject */.i)("headerBackgroundImage"), ",\n          ").concat((0,LocaleString/* LocaleString */.E)("headerTitle"), ",\n          ").concat((0,LocaleString/* LocaleString */.E)("headerIntroduction"), ",\n        },\n        ").concat((0,LocaleSeo/* LocaleSeo */.U)("seo"), ",\n      }\n    ")
    });
}
function useGlossaryTermsQuery() {
    return (0,useGroqQuery/* useGroqQuery */.Mo)({
        operationName: "GlossaryTerms",
        query: '\n      *[_type == "GlossaryTerm"] {\n        "puid": puid.current,\n        '.concat((0,LocaleTag/* LocaleTag */.p)("tags[]->"), ",\n        ").concat((0,LocaleString/* LocaleString */.E)("term"), ",\n        ").concat((0,LocalePortableText/* LocalePortableText */.O)("definition"), ",\n        ").concat((0,SanityImageObject/* SanityImageObject */.i)("image"), ",\n        ").concat((0,SanityVideoObject/* SanityVideoObject */.o)("video"), ",\n      }\n    ")
    });
}
function Glossary() {
    var ref, ref1;
    var ref2 = (0,_sliced_to_array/* default */.Z)(useGlossaryPageQuery(), 1), glossaryPage = ref2[0];
    var ref3 = (0,_sliced_to_array/* default */.Z)(useGlossaryTermsQuery(), 1), glossaryTerms = ref3[0];
    var page = glossaryPage === null || glossaryPage === void 0 ? void 0 : (ref = glossaryPage.data) === null || ref === void 0 ? void 0 : ref.content;
    var terms = glossaryTerms === null || glossaryTerms === void 0 ? void 0 : (ref1 = glossaryTerms.data) === null || ref1 === void 0 ? void 0 : ref1.content;
    return page && terms ? /*#__PURE__*/ (0,jsx_runtime.jsx)(GlossaryPage, {
        page: page,
        terms: terms
    }) : null;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9294,6740,9774,2888,179], function() { return __webpack_exec__(99830); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);